// extracted by mini-css-extract-plugin
export default {"page":"wX-z","cartModal":"xX-z","checkout":"yX-z","placeholder":"zX-z","account":"AX-z"};